import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from '@nosto/preact'
import { productImagePlaceholder, imageResizer } from '../helpers'
import { useEffect, useState } from 'preact/hooks'
import SubmitButton from './elements/SubmitButton'

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    useEffect(() => {
        if (window.innerWidth <= 768) return;

        // Main header element
        const mainHeader = document.querySelector('.site-header-wrapper')
    
        // Create and move backdrop element just before mainHeader
        let backdrop = document.querySelector('.ns-autocomplete-backdrop.ns-fixed.ns-w-100.ns-h-100.ns-background-black')
        if (!backdrop) {
            backdrop = document.createElement('div')
            backdrop.className = 'ns-autocomplete-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black'
            if (mainHeader) {
                mainHeader.parentElement.insertBefore(backdrop, mainHeader)
            }
        }
    
        // Add event listener to the backdrop to change its display to none when clicked
        const handleBackdropClick = () => {
            backdrop.style.display = 'none'
        }
        backdrop.addEventListener('click', handleBackdropClick)
    
        // Add event listener to the mainHeader to change the backdrop's display to block when clicked
        const handlemainHeaderClick = () => {
            backdrop.style.display = 'block'
        }
        mainHeader.addEventListener('click', handlemainHeaderClick)
    
        // Add event listener to the closeButton to hide the backdrop and change the parent element's display to none when clicked
        const closeButton = document.querySelectorAll('.ns-autocomplete .ns-close-autocomplete svg')
        closeButton.forEach(function (elem) {
            elem.addEventListener('click', function (e) {
                e.stopPropagation()
                backdrop.style.display = 'none'
                const desktopHeader = document.querySelector('.site-header__controls.text-right.icon-container')
                const nsAutocomplete = desktopHeader.querySelector('.ns-autocomplete.ns-fixed')
                console.log("nsAutocomplete", nsAutocomplete)
                if (nsAutocomplete) {
                    nsAutocomplete.parentElement.style.display = 'none'
                }
            })
        })

        return () => {
            backdrop.removeEventListener('click', handleBackdropClick)
            mainHeader.removeEventListener('click', handlemainHeaderClick)
            closeButton.forEach(function (elem) {
                elem.removeEventListener('click', function (e) {
                    e.stopPropagation()
                    backdrop.style.display = 'none'
                    const nsAutocomplete = document.querySelector('.ns-autocomplete')
                    if (nsAutocomplete) {
                        nsAutocomplete.parentElement.style.display = 'none'
                    }
                })
            })
        }
    }, [products?.hits?.length > 0 && keywords?.hits?.length > 0])

    // Jacopo script for updating images' size -> https://nostosolutions.atlassian.net/browse/FEA-10448
    const [imageWidths, setImageWidths] = useState({});
    const handleImageLoad = (index, img) => {
        setImageWidths((prevWidths) => ({
            ...prevWidths,
            [index]: img.offsetWidth,
        }));

    };

    useEffect(() => {
        setImageWidths({}); 
    }, [products.hits]);
    //end of script -> https://nostosolutions.atlassian.net/browse/FEA-10448

    return (
        <>
            <div
                class="ns-autocomplete ns-fixed ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
                data-nosto-element="autocomplete">
                <div class="ns-w-100 ns-mt-sm-auto">
                    <div class="ns-close-autocomplete">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none">
                            <path
                                d="M18.9999 1L1.25488 18.745L18.9999 1Z"
                                stroke="#222222"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                            />
                            <path
                                d="M18.745 18.745L1 1L18.745 18.745Z"
                                stroke="#222222"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                            />
                        </svg>
                    </div>
                    <div class="ns-d-flex ns-flex-column ns-flex-sm-row ns-autocomplete-mobileView">
                        {keywords?.hits?.length > 0 && (
                            <div
                                class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
                                    products?.hits?.length > 0 ? 'ns-col-sm-4' : 'ns-col-sm-12'
                                }`}>
                                {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Keywords
                            </div> */}
                                <div>
                                    <span class="heading-6 ns-px-4">SUGGESTIONS</span>
                                </div>
                                <div class="ns-d-flex ns-flex-column">
                                    <Keywords
                                        hits={keywords.hits}
                                        keywordComponent={Keyword}
                                        elementComponent={Element}
                                        keywordInCategoryComponent={KeywordInCategory}
                                    />
                                </div>
                                {!products?.hits?.length && <SubmitButton text="See all search results" />}
                            </div>
                        )}
                        {products?.hits?.length > 0 && (
                            <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1 ns-px-5">
                                {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Products
                            </div> */}
                                <div class="ns-autocomplete-productTitle">
                                    <span class="heading-6 ns-pl-5">TOP RESULTS</span>
                                </div>
                                <div class="ns-d-flex ns-flex-row ns-flex-xs-wrap ns-product-wrapper">
                                    {products?.hits?.map((hit, index) => {
                                        return (
                                            <AutocompleteElement hit={hit}>
                                                <div
                                                    data-url={hit.url}
                                                    class="ns-d-flex flex-column ns-clickable"
                                                    data-nosto-element="product">
                                                    <img
                                                        class="ns-h-auto ns-object-contain autocomplete-img primary-img"
                                                        onLoad={(e) => handleImageLoad(index, e.target)}
                                                        src={
                                                            imageWidths[index]
                                                                ? imageResizer(hit.imageUrl, imageWidths[index]) // Use dynamic width
                                                                : hit.imageUrl // Fallback while waiting for width
                                                        }
                                                        alt={hit.name}
                                                        width="60"
                                                        height="40"
                                                    />
                                                    {/* <img
                                                        class="ns-h-auto ns-object-contain autocomplete-img primary-img"
                                                        src={
                                                            imageResizer(hit.imageUrl, 200) ??
                                                            productImagePlaceholder
                                                        }
                                                        alt={hit.name}
                                                        width="60"
                                                        height="40"
                                                    /> */}
                                                    <div>
                                                        <div class="ns-my-2 ns-font-4 ns-clipped ns-text-one-line product__title heading-6">
                                                            {hit.name}
                                                        </div>
                                                        <div style="display:flex;gap:7px;">
                                                            {hit.listPrice && hit.listPrice > hit.price && (
                                                                <>
                                                                    <span
                                                                        class="sale-price"
                                                                        data-collection-item-sale-price="">
                                                                        {format(hit.price)
                                                                            .toString()
                                                                            .replace('.00', '')}
                                                                    </span>
                                                                    <s data-collection-item-compare-price="">
                                                                        {format(hit.listPrice)
                                                                            .toString()
                                                                            .replace('.00', '')}
                                                                    </s>
                                                                </>
                                                            )}
                                                            {!hit.listPrice ||
                                                                (hit.listPrice == hit.price && (
                                                                    <p
                                                                        class="collection-item__price ns-price"
                                                                        data-collection-item-price="">
                                                                        <span data-collection-item-sale-price="">
                                                                            {format(hit.price)
                                                                                .toString()
                                                                                .replace('.00', '')}
                                                                        </span>
                                                                    </p>
                                                                ))}
                                                            {/* <span class="main-price">{format(hit.price).toString().replace(".00", "")}</span>
                                                        {hit.listPrice && hit.listPrice > hit.price && (
                                                            <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2 sale-price">
                                                                {format(hit.listPrice).toString().replace(".00", "")}
                                                            </span>
                                                        )} */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </AutocompleteElement>
                                        )
                                    })}
                                </div>
                                <SubmitButton text="See all search results" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword,
                    }}></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-px-4 ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{' '}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
